<template>
  <v-card
    v-if="
      (relatorio.AjustesNutricionais &&
        (relatorio.CotacaoInsumoNutricional ||
          relatorio.PesagemLeiteApp ||
          relatorio.PesagemLeiteCaderno ||
          relatorio.RemanejamentoLotes ||
          relatorio.SeguirArracoamento ||
          relatorio.RecomendacaoNutricional ||
          relatorio.Step8Atividade1 ||
          relatorio.Step8Atividade2 ||
          relatorio.Step8Atividade3 ||
          relatorio.Step8Atividade4 ||
          relatorio.Step8Atividade5 ||
          relatorio.Step8Atividade6 ||
          relatorio.Step8Atividade7 ||
          relatorio.Step8OutrasAtividades ||
          relatorio.Step8OutrasAtividadesText)) ||
      relatorio.AjustesNutricionaisObs
    "
    class="ma-4"
  >
    <v-card-title style="text-align: left">Ajustes nutricionais</v-card-title>
    <v-card-text>
      <v-row v-if="relatorio.AjustesNutricionais" class="pa-3">
        <v-col
          v-if="
            relatorio.Step8Atividade1 ||
            relatorio.Step8Atividade2 ||
            relatorio.Step8Atividade3 ||
            relatorio.Step8Atividade4 ||
            relatorio.Step8Atividade5 ||
            relatorio.Step8Atividade6 ||
            relatorio.Step8Atividade7 ||
            relatorio.Step8OutrasAtividades
          "
          cols="12"
          class="col-bordered"
        >
          <span class="key-title">Atividades realizadas</span>
          <v-col v-if="relatorio.Step8Atividade1" cols="12">
            <span class="value-title"
              >Lançamento do controle leiteiro no sistema</span
            >
          </v-col>
          <v-col
            v-if="
              relatorio.Step8Atividade2 == '1' &&
              relatorio.Step8Atividade2Text != ''
            "
            cols="12"
          >
            <span class="value-title">Avaliação do escore de cocho: </span>
            <br />
            <span class="value-title">{{
              relatorio.Step8Atividade2Text || '-'
            }}</span>
          </v-col>
          <v-col
            v-if="
              relatorio.Step8Atividade3 == '1' &&
              relatorio.Step8Atividade3Text != ''
            "
            cols="12"
          >
            <span class="value-title"
              >Avaliação da estrutura de alimentação (espaço de cocho/animal,
              condições físicas das estruturas):
            </span>
            <br />
            <span class="value-title">{{
              relatorio.Step8Atividade3Text || '-'
            }}</span>
          </v-col>
          <v-col
            v-if="
              relatorio.Step8Atividade4 == '1' &&
              relatorio.Step8Atividade4Text != ''
            "
            cols="12"
          >
            <span class="value-title">Análise da dieta atual: </span>
            <br />
            <span class="value-title">{{
              relatorio.Step8Atividade4Text || '-'
            }}</span>
          </v-col>
          <v-col
            v-if="
              relatorio.Step8Atividade5 == '1' &&
              relatorio.Step8Atividade5Text != ''
            "
            cols="12"
          >
            <span class="value-title"
              >Divisão de lotes (Vacas em lactação):
            </span>
            <br />
            <span class="value-title">{{
              relatorio.Step8Atividade5Text || '-'
            }}</span>
          </v-col>
          <v-col
            v-if="
              relatorio.Step8Atividade6 == '1' &&
              relatorio.Step8Atividade6Text != ''
            "
            cols="12"
          >
            <span class="value-title">Divisão de lotes (Recria): </span>
            <br />
            <span class="value-title">{{
              relatorio.Step8Atividade6Text || '-'
            }}</span>
          </v-col>
          <v-col
            v-if="
              relatorio.Step8Atividade7 == '1' &&
              relatorio.Step8Atividade7Text != ''
            "
            cols="12"
          >
            <span class="value-title">Balanceamento da dieta: </span>
            <br />
            <span class="value-title">{{
              relatorio.Step8Atividade7Text || '-'
            }}</span>
          </v-col>
          <v-col v-if="relatorio.Step8OutrasAtividades" cols="12">
            <span class="key-title">Outras Atividades: </span> <br />
            <span class="value-title">{{
              relatorio.Step8OutrasAtividadesText || '-'
            }}</span>
          </v-col>
        </v-col>

        <v-col
          v-if="
            relatorio.CotacaoInsumoNutricional ||
            relatorio.PesagemLeiteApp ||
            relatorio.PesagemLeiteCaderno ||
            relatorio.RemanejamentoLotes ||
            relatorio.SeguirArracoamento ||
            relatorio.RecomendacaoNutricional
          "
          cols="12"
          class="col-bordered"
        >
          <span class="key-title">Recomendações:</span>
          <v-col v-if="relatorio.CotacaoInsumoNutricional" cols="12">
            <span class="value-title"
              >Fazer cotação de insumos para custo da dieta
            </span>
          </v-col>
          <v-col v-if="relatorio.PesagemLeiteApp" cols="12">
            <span class="value-title"
              >Realizar a pesagem mensal de leite e lançar a pesagem no
              aplicativo
            </span>
          </v-col>
          <v-col v-if="relatorio.PesagemLeiteCaderno" cols="12">
            <span class="value-title"
              >Realizar a pesagem mensal de leite e lançar a pesagem no caderno
              zootécnico
            </span>
          </v-col>
          <v-col v-if="relatorio.RemanejamentoLotes" cols="12">
            <span class="value-title"
              >Realizar o remanejamento dos lotes conforme listagem em anexo
            </span>
          </v-col>
          <v-col v-if="relatorio.SeguirArracoamento" cols="12">
            <span class="value-title"
              >Seguir arraçoamento proposto em anexo
            </span>
          </v-col>
          <v-col v-if="relatorio.RecomendacaoNutricional" cols="12">
            <span class="key-title">Outras recomendações: </span> <br />
            <span class="value-title">{{
              relatorio.RecomendacaoNutricional || '-'
            }}</span>
          </v-col>
        </v-col>
      </v-row>
      <v-row v-else justify="center">
        <v-col>
          <span class="key-title">Atividade não realizada </span> <br />
          <span class="value-title">{{
            relatorio.AjustesNutricionaisObs || '-'
          }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AjustesNutricionais',
  props: {
    relatorio: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  methods: {
    maskIdentify(raw) {
      return raw ? raw.split('|') : ['Nenhum insumo identificado']
    },
  },
}
</script>

<style scoped>
.key-title {
  font-weight: 500;
  font-size: '16px';
  line-height: 40px;
}

.value-title {
  font-size: '16px';
}

.col-bordered {
  border: solid 1px #ccc;
}
</style>
